export default __webpack_public_path__ + "static/media/20.d9350e50.png";